/**
 * Created by roman.kupin on 7/27/2017.
 */


/*export */
class Representatives {

    static intro = ['diane', 'ed', 'gisele', 'guido', 'hal', 'jeanmichel', 'jessica', 'jon', 'joseph', 'mike', 'richardtoms'];
    static dmo = ['diane', 'ed', 'guido'];
    static vr = ['diane', 'ed', 'gisele', 'guido', 'hal', 'jeanmichel', 'jessica', 'jon', 'joseph', 'mike'];
    static vrexperiencekissimmee = ['ed'];
    static siteminder = ['ed', 'guido', 'joseph', 'mike'];
    static innquest = ['ed'];
    static benchmark = ['ed'];
    static chta = ['ed'];
    static navis = ['ed'];
    static milemarker630 = ['allison'];
    static experiencekissimmee = ['ed'];
    static fuel = ['ed'];
    static jackrabbit = ['ed'];
    static visitflorida = ['ed'];
    static intercoastalnet = ['ed'];
    static resortdataprocessing = ['ed'];

    static introFallback = ['ed'];
    static dmoFallback = ['ed'];
    static vrFallback = ['ed'];
    static vrexperiencekissimmeeFallback = ['ed'];
    static siteminderFallback = ['ed'];
    static innquestFallback = ['ed'];
    static benchmarkFallback = ['ed'];
    static chtaFallback = ['ed'];
    static navisFallback = ['ed'];
    static milemarker630Fallback = ['allison'];
    static experiencekissimmeeFallback = ['ed'];
    static fuelFallback = ['ed'];
    static jackrabbitFallback = ['ed'];
    static visitfloridaFallback = ['ed'];
    static intercoastalnetFallback = ['ed'];
    static resortdataprocessingFallback = ['ed'];
    static redirects = [/^alfredo$/gi, /^brandon$/gi, /^chris$/gi, /^danielle$/gi, /^david$/gi, /^debi$/gi, /^geetha$/gi, /^jeff$/gi, /^monica$/gi, /^raul$/gi, /^richard$/gi];

    constructor(public pool: string[],
                public fallback: string[]) {
    }

    canRepresent(name: string): boolean {
        return this.pool.filter((poolName) => poolName === name).length > 0;
    }

    get(): string {
        return Representatives.getRandomFromArray(this.pool);
    }

    getFallback(name: string): string {
        let redirect = this.checkRedirect(name);
        if (!redirect)
            return Representatives.getRandomFromArray(this.fallback);
        else return redirect;
    }

    private checkRedirect(name: string) {
        if (Representatives.redirects.some(r => r.test(name)) && this.fallback.filter((fallbackName) => fallbackName === 'ed').length > 0)
            return 'ed';
        return null;
    }

    private static getRandomFromArray(array: any[]) {
        return array[Representatives.getRandomInt(0, array.length - 1)];
    }

    private static getRandomInt(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}


angular.module("fliptoWeb")
    .factory("representatives", [function () {

        return function (introType) {
            switch (introType) {
                case "intro":
                    return new Representatives(Representatives.intro, Representatives.introFallback);
                case "dmo":
                    return new Representatives(Representatives.dmo, Representatives.dmoFallback);
                case "vr":
                    return new Representatives(Representatives.vr, Representatives.vrFallback);
                case "vrexperiencekissimmee":
                    return new Representatives(Representatives.vrexperiencekissimmee, Representatives.vrexperiencekissimmeeFallback);
                case "siteminder":
                    return new Representatives(Representatives.siteminder, Representatives.siteminderFallback);
                case "innquest":
                    return new Representatives(Representatives.innquest, Representatives.innquestFallback);
                case "benchmark":
                    return new Representatives(Representatives.benchmark, Representatives.benchmarkFallback);
                case "chta":
                    return new Representatives(Representatives.chta, Representatives.chtaFallback);
                case "navis":
                    return new Representatives(Representatives.navis, Representatives.navisFallback);
                case "milemarker630":
                    return new Representatives(Representatives.milemarker630, Representatives.milemarker630Fallback);
                case "experiencekissimmee":
                    return new Representatives(Representatives.experiencekissimmee, Representatives.experiencekissimmeeFallback);
                case "fuel":
                    return new Representatives(Representatives.fuel, Representatives.fuelFallback);
                case "jackrabbit":
                    return new Representatives(Representatives.jackrabbit, Representatives.jackrabbitFallback);
                case "visitflorida":
                    return new Representatives(Representatives.visitflorida, Representatives.visitfloridaFallback);
                case "intercoastalnet":
                    return new Representatives(Representatives.intercoastalnet, Representatives.intercoastalnetFallback);
                case "resortdataprocessing":
                    return new Representatives(Representatives.resortdataprocessing, Representatives.resortdataprocessingFallback);
                default:
                    throw "intro type is not supported";
            }
        }
    }]);

